import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const toastComponent = {
  root: 'toast.root',
} as const satisfies ComponentLocatorMap;
